import { render, staticRenderFns } from "./DocumentReceptions.vue?vue&type=template&id=8d8a1700&scoped=true&"
import script from "./DocumentReceptions.vue?vue&type=script&lang=js&"
export * from "./DocumentReceptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8a1700",
  null
  
)

export default component.exports